import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import DocsPage from "./pages/DocsPage";
import EslPage from "./pages/EslPage";
import EslDemoGodot from "./pages/EslDemoGodot";
import EslDemoIndustrial from "./pages/EslDemoIndustrial";
import EslDemoNegocios from "./pages/EslDemoNegocios";
import CliPage from "./pages/CliPage";
import MarketplacePage from "./pages/MarketplacePage";
import DownloadPage from "./pages/DownloadPage";
import LegalTerms from "./pages/LegalTerms";
import LegalPrivacy from "./pages/LegalPrivacy";
import LegalLicense from "./pages/LegalLicense";
import { Toaster } from "./components/ui/sonner";
import { PlaygroundProvider } from "./contexts/PlaygroundContext";

function App() {
  return (
    <div className="App">
      <PlaygroundProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/docs/:category/:topic" element={<DocsPage />} />
            <Route path="/embedded-scripting-language" element={<EslPage />} />
            <Route path="/embedded-scripting-language/demo-godot" element={<EslDemoGodot />} />
            <Route path="/embedded-scripting-language/demo-industrial" element={<EslDemoIndustrial />} />
            <Route path="/embedded-scripting-language/demo-negocios" element={<EslDemoNegocios />} />
            <Route path="/cli" element={<CliPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/legal/terms" element={<LegalTerms />} />
            <Route path="/legal/privacy" element={<LegalPrivacy />} />
            <Route path="/legal/license" element={<LegalLicense />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </PlaygroundProvider>
    </div>
  );
}

export default App;
